import { ShareModalComponent } from '@/app/components/shared/share-modal/share-modal.component';
import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { MatchApi } from '@/app/pages/sports/football/home/models';
import { MatchFavoriteService } from '@/app/services/favorite/match-favorite.service';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@environments/environment';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@Component({
  selector: 'app-icons-resource',
  standalone: true,
  imports: [NzPopoverModule, ShareModalComponent, RouterLink],
  templateUrl: './icons-resource.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsResourceComponent {
  private fMatchService = inject(MatchFavoriteService);

  urlIcon = environment.urlIcon;

  urlMatch = input.required<string>();
  statusMatch = input.required<string>();
  match = input.required<MatchApi>();
  matchId = input.required<string>();
  selectedDate = input.required<string>();
  tsExternalCompetitionId = input.required<string>();

  favoriteMatch = computed(() =>
    this.fMatchService.favoritesService
      .idsMatchesFavorites()
      .includes(this.match().Id)
  );
  openModalShared = signal<boolean>(false);

  closedMoadl() {
    this.openModalShared.set(false);
  }

  toogleModalShared = () => {
    this.openModalShared.update((state) => !state);
  };
  getImgFavorite(): string {
    return this.favoriteMatch()
      ? this.urlIcon + 'fav-red.svg'
      : this.urlIcon + 'fav-grey.svg';
  }

  toogleFavoriteMatch() {
    const isFavorite = this.favoriteMatch();

    if (isFavorite) {
      this.fMatchService.deleteMatchFavorites(this.match().Id, this.match());
    } else {
      this.fMatchService.setMatchFavorites(this.match().Id, this.match());
    }
  }

  viewOddIcon() {
    return false;
    // return this.statusMatch() === EStatusMatches.NORMAL;
  }

  getLinkOddIcon() {
    return `/Futbol/match-odds`;
  }

  handlePropagation(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  getLinkShared() {
    return `${environment.urlApp}${this.urlMatch()}`;
  }

  viewIconFavorite() {
    if (this.match().Status === EStatusMatches.ENDED) {
      return false;
    }

    return true;
  }
}
